import { Directive, ElementRef, HostListener, inject } from "@angular/core";

@Directive({
  selector: "[avTrimInput]",
  standalone: false,
})
export class TrimInputDirective {
  private el = inject(ElementRef);


  @HostListener("blur") onBlur() {
    this.el.nativeElement.value = this.el.nativeElement.value.trim();
  }
}
